export const RECENT_TRANSCRIPTS_PAGE_SIZE = 20;
export const AI_WRITER_PROMPT_BOX_ID = 'ai-voice-writer-panel-prompt-box';
export const AI_WRITER_SESSION_STORAGE_KEY = 'ai-voice-writer-data';
export const AI_WRITER_CONTEXTUAL_MENU_WIDTH = 300;

export interface AiWriterPanelViewProps {
  isOpenedInPopOver: boolean;
  onBack: () => void;
  onClose: () => void;
  onContentSelected: (text: string) => void;
}
